import { createContext } from 'react';

export interface GoogleMapsContextValue {
  apiKey: string,
  sessionToken: google.maps.places.AutocompleteSessionToken,
}

export const GoogleMapsContext = createContext<GoogleMapsContextValue>({
  apiKey: null,
  sessionToken: null,
});
